( function () {
    'use strict';
    ( function ( $ ) {
        $('.tabs-nav-item').on('click',function(e){
            e.preventDefault();
            $('a[data-tab-panel]').removeClass('active');
            var tabID = $(this).data('tab-panel');
            $('a[data-tab-panel="'+tabID+'"]').addClass('active');
            $('.tab-panel.active').removeClass('active').css({"opacity":"0"});
            $('#'+tabID).addClass('active').css({"opacity":"0"}).animate({opacity:1});
            if(tabID === 'tab-advisory-team'){
                $('.tabs-wrap').removeClass('emerald-tab-wrap');
                $('.tabs-wrap').addClass('advisory-tab-wrap');
            }
            else{
                $('.tabs-wrap').removeClass('advisory-tab-wrap');
                $('.tabs-wrap').addClass('emerald-tab-wrap');
            }
        });
        $('.filter-nav a').on('click',function(e){
            e.preventDefault();
            var type = $(this).data('type');
            $('.filter-nav a.active').removeClass('active');
            $(this).addClass('active');
            $("#tab-emerald-team .team-col").addClass('hide');
            $("#tab-emerald-team .team-col[class~='"+type+"']").removeClass('hide').css({"opacity":"0"}).animate({opacity:1});;
            $('.filter-nav').removeClass('active');
        });
        $('.team-filter a.mobile-only').on('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            if(!$('.filter-nav').hasClass('active')){
                $('.filter-nav').addClass('active');
            }
            else{
                $('.filter-nav').removeClass('active');
            }
        });
        $(document).click(function(e) {
            $('.filter-nav').removeClass('active');            
        });
    } )( jQuery );
} )();